import { put } from "redux-saga/effects";
import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/preferredPartners/messages";
import { camelizeKeys } from "lib/helpers";

function* getPreferredPartnersAdmin(action) {
  const { success, data, error } = yield* makeRequest.get("/enterprise_labor_partners/admin", action.payload);
  if (success && data) {
    const list = camelizeKeys(data.body.enterprises_with_partners);
    const paging = camelizeKeys(data.body.paging);
    yield put(actions.setPreferredPartnersAdmin({ list, paging }));
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_PREFERRED_PARTNERS,
    });
  }

  return null;
}

export default getPreferredPartnersAdmin;
